{
  "en": {
    "issue_list": {
      "actions": {
        "add_units": "Units",
        "all_units_assigned": "All units assigned",
        "change_responsible": "Change responsible",
        "check": "Check",
        "create_issue_lists": "Create snagging list | Create snagging lists",
        "delete": "Delete",
        "delete_count": "You are about to delete snags for {count} unit. Are you sure? | You are about to delete snags for {count} units. Are you sure?",
        "delete_issue_lists": "Delete snags",
        "edit": "Edit",
        "edit_issue_list": "Edit snagging list type",
        "export": "Export",
        "generatePDF": "Generate PDF",
        "go_to_summary": "Go to summary",
        "new": "Snag",
        "new_customer": "Report defect",
        "new_issue_list": "Snagging list",
        "selectAll": "Select all {total} lists",
        "unSelectAll": "Clear selection",
        "update": "Update"
      },
      "attributes": {
        "date": "Start date",
        "description": "Description",
        "name": "Name"
      },
      "labels": {
        "aftercare_conversations": "Aftercare conversations",
        "aftercare_conversations_toggle": "Enable conversations within aftercare",
        "assign_to_list": "Assign to list",
        "collapse_all": "Collapse",
        "completed_header": "{completed_count} out of {issues_count} snags completed",
        "customer": "Customer",
        "date": "Start date (optional)",
        "delete_explanation": "All snags, together with their images and documents, will be permanently removed from the platform.",
        "description_title": "Add a description",
        "deselect_all": "Deselect all",
        "edit_multiple": "Edit {count} issue lists",
        "hide_count": "Unpublish snags for 1 unit | Unpublish snags for {count} units",
        "hide_count_SUP": "Unpublish snags",
        "issue_list": "Snagging list",
        "issue_lists": "Aftercare",
        "issue_lists_all_projects": "Aftercare all projects",
        "no_issues_to_export": "No issues to export",
        "no_lists_completed": "No lists completed",
        "open_all": "Open",
        "partners": "Partners",
        "pdf_generated_successfully": "PDF generated successfully",
        "process_issues": "Assign to list",
        "project_units_total": "{project_name} has {units_count_max} units in total",
        "publish_now": "Publish now?",
        "published_count": "Publish snags for 1 unit | Publish snags for {count} units",
        "published_count_SUP": "Publish snags",
        "save_explainer": "Make the (future) snags visible for your customers? Or save and publish later?",
        "selectOne": "Select at least 1 list",
        "select_all": "Select all",
        "selected": "{selected} list selected. | {selected} lists selected",
        "status": "status",
        "step_1_info": "E.g. preliminary or final delivery, snags for the kitchen or bathrooms,...",
        "step_1_title": "What type of snagging list do you want to make?",
        "step_2_subtitle": "Select your project to include all your units at once. You can always add more units later.",
        "step_2_title": "Which units do you want to log snags for?",
        "tab_issue_list_documents": "Documents",
        "tab_issue_list_issues": "Snags",
        "tab_issue_list_issues_customer": "Aftercare",
        "tab_issue_list_tickets": "Conversations",
        "tab_issues": "All Snags",
        "tab_units": "Units",
        "totalSelected": "All {total} lists are selected",
        "you_have_customer_issues": "You have 1 unprocessed customer snag | You have {number} unprocessed customer snags"
      },
      "navigation": {
        "back_to_issue_lists": "Back to snagging lists"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Follow up on reported snags",
            "title": "All your snags will be shown here"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Create snags for units attached to the list",
            "title": "Create your first list of snags"
          }
        },
        "partners": {
          "subtitle": "You'll be notified when new snags have been created",
          "title": "No snags assigned to you yet"
        }
      },
      "validation": {
        "name_already_taken": "Name is already taken for this project.",
        "need_name": "Name is required"
      }
    }
  }
}